import {
  BOT_LOADED, BOT_VIDEO_AVATAR_LOADED, BOTS_LOADED, CLEAR_NOT_FOUND_EMAILS, CLEAR_PARTICIPANT_ERROR, DIALOGUE_CLEARED,
  DIALOGUE_LOADED, PARTICIPANT_ERROR, PARTICIPANT_LOADED,
  PARTICIPANTS_LOADED,
  SET_DIALOGUES, SET_NOT_FOUND_EMAILS, USERS_LOADED, XPEDITIONS_LOADED
} from './actions';
import {
  IDialogueActionHandler,
  IDialogueInitialState,
  IDialogueCard,
  IParticipant,
  IBot,
  IBotUser
} from './interfaces';
import {DialogueActionsType} from './actions';
import {IBot as IBotWithSettings, IXpedition} from '../../utils/hooks/use-chat-bot/interfaces';
import {IVideoAvatar} from '../auth/interfaces';

const DialogueInitialState: IDialogueInitialState = {
  dialogues: [],
  dialogue: null,
  participant: null,
  participantError: null,
  participants: [],
  bots: [],
  bot: null,
  botVideoAvatar: null,
  users: [],
  xpeditions: [],
  notFoundEmails: []
};

const setDialogues = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    dialogues: payload as IDialogueCard[]
  };
};

const setDialogue = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    dialogue: payload as IDialogueCard
  };
};

const clearDialogue = ({
  state
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    dialogue: null,
    participant: null,
    participants: [],
    participantError: null
  };
};

const setParticipants = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    participants: payload as IParticipant[]
  };
};

const setParticipant = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    participant: payload as IParticipant
  };
};

const setParticipantError = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    participantError: payload as string
  };
};

const clearParticipantError = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    participantError: null
  };
};

const setBots = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    bots: payload as IBot[]
  };
};

const setBot = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    bot: payload as IBotWithSettings
  };
};

const setBotVideoAvatar = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    botVideoAvatar: payload as IVideoAvatar
  };
};

const setUsers = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    users: payload as IBotUser[]
  };
};

const setXpeditions = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    xpeditions: payload as IXpedition[]
  };
};

const setNotFoundEmails = ({
  state,
  payload
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    notFoundEmails: payload as string[]
  };
};

const clearNotFoundEmails = ({
  state
}: IDialogueActionHandler): IDialogueInitialState => {
  return {
    ...state,
    notFoundEmails: []
  };
};

const statusReducerHandlers = new Map([
  [SET_DIALOGUES, setDialogues],
  [DIALOGUE_LOADED, setDialogue],
  [PARTICIPANT_LOADED, setParticipant],
  [PARTICIPANT_ERROR, setParticipantError],
  [CLEAR_PARTICIPANT_ERROR, clearParticipantError],
  [PARTICIPANTS_LOADED, setParticipants],
  [BOTS_LOADED, setBots],
  [BOT_LOADED, setBot],
  [BOT_VIDEO_AVATAR_LOADED, setBotVideoAvatar],
  [XPEDITIONS_LOADED, setXpeditions],
  [USERS_LOADED, setUsers],
  [DIALOGUE_CLEARED, clearDialogue],
  [SET_NOT_FOUND_EMAILS, setNotFoundEmails],
  [CLEAR_NOT_FOUND_EMAILS, clearNotFoundEmails]
]);

const contentReducer = (state = DialogueInitialState, action: DialogueActionsType): IDialogueInitialState => {
  const handler = statusReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IDialogueActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default contentReducer;
